import { render, staticRenderFns } from "./ReviewProcess.vue?vue&type=template&id=78bbe906&scoped=true"
import script from "./ReviewProcess.vue?vue&type=script&lang=js"
export * from "./ReviewProcess.vue?vue&type=script&lang=js"
import style0 from "./ReviewProcess.vue?vue&type=style&index=0&id=78bbe906&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bbe906",
  null
  
)

export default component.exports